import * as React from 'react';
// @ts-expect-error
import {components} from 'react-select';
// @ts-expect-error
import type {SelectBaseProps, OptionProps} from 'react-select';

import {SelectPickerGeneric} from '../select-picker-generic/select-picker-generic';

import styles from './select-two-line.module.css';

export type TwoLineOption = {
    value: any;
    label: string;
    sublabel: string;
};

type Props = SelectBaseProps & {
    isMulti?: false;
    onChange: SelectPickerGeneric['props']['onChange'];
    options: TwoLineOption[];
    value: TwoLineOption | null | undefined;
    placeholder?: string;
};

export class SelectTwoLine extends React.PureComponent<Props> {
    // @ts-expect-error
    selectInputRef: HTMLElement;

    render() {
        const {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            isClearable,
            ...restProps
        } = this.props;

        return (
            <div className={styles.container}>
                <div className={styles['select-container']}>
                    <SelectPickerGeneric
                        {...restProps}
                        isClearable={false}
                        openMenuOnFocus={true}
                        components={{
                            Option: OptionComponent,
                        }}
                        placeholder={this.props.placeholder}
                    />
                </div>
            </div>
        );
    }
}

const OptionComponent = ({...props}: OptionProps) => {
    return (
        <components.Option {...props}>
            <div>
                <div className={styles['option-title']}>{props.data.label}</div>
                <div className={styles['option-subtitle']}>{props.data.sublabel}</div>
            </div>
        </components.Option>
    );
};
